import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { UserInfo } from 'src/app/store/actions/user.action';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { AppState } from 'src/app/store/app.states';
import { getUserInfo } from 'src/app/store/selector/selector';

declare var $;
@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent {
  user:any;
  showmsg=false;
  redirectScheduled=false;
  constructor(public webApi: WebapiService,private store: Store<AppState>,public router: Router) {
  }

  click(){
    if ($('.dropdown-menu.login').is(":hidden")){
      $('.dropdown-menu.login').dropdown('toggle');
    }
  }

  ngOnInit()  
  {
    this.handleCheckoutReturnCode();
    setTimeout(()=>{
      this.getUserData()
    },1000)
  }

  handleCheckoutReturnCode(){
    const searchParams = new URLSearchParams(window.location.search || '');
    let code = searchParams.get('rcode') || '';
    if(!code){
    const hash = (window.location.hash || '').replace('#', '');
    if(!hash){
      return;
    }
    const params = new URLSearchParams(hash);
      code = params.get('code') || '';
    }
    if(!code){
      return;
    }
    this.webApi.exchangeCheckoutReturn(code).subscribe((data: any) => {
      if(data && data.success && data.token){
        this.webApi.setSession(data);
        this.store.dispatch(new UserInfo());
        window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
        this.scheduleVideoRedirect();
      }
    });
  }

  getUserData(){
    this.webApi.setLoader(true)
    if(this.webApi.isLoggedIn()){
      this.showmsg=true;
      this.scheduleVideoRedirect();
    }else{
      this.showmsg=false;
    }
    this.webApi.setLoader(false)
    // this.store.pipe(select(getUserInfo)).subscribe(data=>{
    //   this.user = data
    //   this.webApi.setLoader(false)
    //   if(this.user && this.user.id){
    //     this.showmsg=true;
    //   }else{
    //     this.showmsg=false;
    //   }
    // },error=>{
    //   this.webApi.setLoader(false)
    // })
  }

  scheduleVideoRedirect(){
    if(this.redirectScheduled){
      return;
    }
    this.redirectScheduled = true;
    setTimeout(()=>{
      this.router.navigateByUrl('/video');
    },2500);
  }
}
